import { render, staticRenderFns } from "./MissingDeals.vue?vue&type=template&id=54734eac&scoped=true"
import script from "./MissingDeals.vue?vue&type=script&lang=js"
export * from "./MissingDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54734eac",
  null
  
)

export default component.exports